import { useState, useEffect } from 'react';
import useFetchWithMsal from './useFetchWithMsal';
import { protectedResources } from '../authConfig';

const useAdminStatus = () => {
    const [isAdmin, setIsAdmin] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const { execute } = useFetchWithMsal({
        scopes: protectedResources.apiScopes.scopes.read,
    });

    useEffect(() => {
        const checkAdminStatus = async () => {
            try {
                const response = await execute(
                    "GET",
                    `${process.env.REACT_APP_BACKEND_BASE_URL}/api/users/status`
                );
                
                setIsAdmin(response?.isAdmin || false);
            } catch (error) {
                console.error("שגיאה בטעינת סטטוס משתמש:", error);
                setIsAdmin(false);
            } finally {
                setIsLoading(false);
            }
        };
        
        checkAdminStatus();
    }, [execute]);

    return { isAdmin, isLoading };
};

export default useAdminStatus;